window.gryp = window.gryp || {};

gryp.Global = {
    initExternalLinks: function() {
        $('a').each(function() {
            var a = new RegExp('/' + window.location.host + '/');
            if (!a.test(this.href) && this.href.indexOf('javascript') == -1) {
                $(this)
                    .addClass('external')
                    .attr('target','_blank')
                    .attr('rel','noopener');
            }
        });
    },
    init: function () {
        this.initExternalLinks();
    }
};

gryp.RelatedSections = {
    removeEmptySections: function() {
        let $sections = $('[id*="-related-"]');
        if ($sections.length) {
            $sections.each(function () {
                if (!$(this).find('.recommendation_content').length) {
                    $(this).remove();
                }
            });
        }
    },
    init: function () {
        this.removeEmptySections();
    }
};

$(document).ready(function () {
    gryp.Global.init();
    gryp.RelatedSections.init();
});